export default __webpack_public_path__ + "static/Claims-Summary-Reports-963c4e14db7183b392a0cd0c44a5d88e.png";